import styled, { css } from 'styled-components';
import { Grid } from 'styled-css-grid';

import { colors } from '@crm-framework/theme';

export const CallWrapper = styled(Grid)`
  height: 100%;
  border-radius: 10px;
  border: 1px solid ${colors.DEFAULT_BORDER};
  background-color: ${colors.PRIMARY_BORDER};
  padding: 10px 15px;
`;

export const CallButtonsWrapper = styled(Grid)`
  height: 100%;
`;

export const CalledMicrophoneWrapper = styled.div`
  position: absolute;
  color: ${colors.PRIMARY};
  right: -14px;
  bottom: -14px;
  border-radius: 50%;
  background: ${colors.PRIMARY_BORDER};
  height: 30px;
  width: 30px;
  justify-content: center;
  align-items: center;
  align-content: stretch;
  display: flex;
`;

export const CallVideoWrapper = styled(Grid)`
  height: 60px;
  align-items: center;
  justify-content: flex-start;
  justify-items: flex-start;
`;

export const EndCallTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CalledBlock = css`
  aspect-ratio: 1 / 1;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  border-radius: 10px;
  border: 1px solid ${colors.PRIMARY_BORDER};
  background-color: ${colors.PRIMARY_DISABLED_BTN_COLOR};
  display: flex;
  color: ${colors.WHITE};
`;

export const CalledBlockVideo = styled.video<{ pending?: boolean }>`
  ${CalledBlock};
  ${({ pending }) => pending && 'filter: brightness(40%);'}
  background-size: cover;
`;

export const CalledBlockAudio = styled.audio`
  ${CalledBlock};
`;

export const CalledBlockWrapper = styled.div`
  position: relative;
  aspect-ratio: 1.2 / 1;
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: end;
  color: ${colors.PRIMARY_DISABLED_BTN_COLOR};
`;
